import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';
import { localPreferences } from 'app-components/utils/core';
// Base
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
// @ts-expect-error FIXME TS7016
import UAParser from 'ua-parser-js';

import { authSelectors } from 'app-components/flux/auth';
import AppStore from 'assets/logos/appStoreBadge.png';
import PlayStore from 'assets/logos/googlePlayBadge.png';
import QButton from 'components/QButton';

const userAgentParser = new UAParser();
const isMobileDevice = window && userAgentParser.getDevice().type === 'mobile';

const useStyles = makeStyles()((theme) => ({
  content: {
    minWidth: 252,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (min-width: 464px)': {
      margin: '6px 12px',
    },
    maxHeight: 'calc(100% - 24px)',
  },
  badges: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    color: theme.palette.secondary.dark,
    margin: 12,
    marginTop: 18,
  },
  continue: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    margin: 12,
  },
  description: {
    maxWidth: 396,
    margin: 6,
    '@media (min-width: 464px)': {
      margin: '6px 12px',
    },
    '@media (min-width: 580px)': {
      margin: '6px 24px',
    },
  },
}));

const MobileDirectDialog = () => {
  const { classes } = useStyles();
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);

  const [showMobileMessage, setShowMobileMessage] = useState(isAuthenticated && isMobileDevice);
  const mobileWarningShown = localPreferences.getMobileWarningShown();

  useEffect(() => {
    setShowMobileMessage(isAuthenticated && isMobileDevice);
  }, [isAuthenticated]);

  const proceed = () => {
    setShowMobileMessage(false);
    localPreferences.setMobileWarningShown(true);
  };

  return showMobileMessage && !mobileWarningShown ? (
    <Dialog open classes={{ paper: classes.content }}>
      <Typography variant='titleMedium' align='center' className={classes.title}>
        It looks like you are coming from a mobile device!
      </Typography>

      <Typography variant='bodyRegular' align='center' className={classes.description}>
        {"Our web app is great, but it isn't optimized for mobile sized screens."}
        <br />
        We suggest you download our iOS or Android app for the best experience.
      </Typography>

      <div className={classes.badges}>
        <Zoom in style={{ transitionDelay: '400ms' }}>
          <div style={{ margin: 10 }}>
            <a href='https://simplifiweb.onelink.me/QdtW/3bc4a7b5'>
              <img
                alt='Download on the AppStore'
                src={AppStore}
                style={{
                  height: 46,
                  borderRadius: 8,
                }}
              />
            </a>
          </div>
        </Zoom>
        <Zoom in style={{ transitionDelay: '400ms' }}>
          <a href='https://simplifiweb.onelink.me/QdtW/3bc4a7b5'>
            <img alt='Get it on Google Play' src={PlayStore} height={60} />
          </a>
        </Zoom>
      </div>

      <div className={classes.continue}>
        <QButton onClick={proceed}>Continue Anyway</QButton>
      </div>
    </Dialog>
  ) : null;
};

export default MobileDirectDialog;
